import React, { useState, useEffect } from 'react';
import DurationDropdown from './DurationDropdown';
import StartTimeInput from './StartTimeInput';
import './RightControls.css';

const RightControls = ({
  onStartTimeChange,
  onAdditionalTimesChange,
  onStaggerMinutesChange,
  disableDurationDropdown,
  onValidationChange,
  onDurationChange, // Pass down from Polls
  selectedDuration // Pass the selected duration down
}) => {
  const [multipleTimes, setMultipleTimes] = useState('');
  const [staggeredBy, setStaggeredBy] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (multipleTimes > 0 && staggeredBy === '') {
      onValidationChange(false);
    } else {
      onValidationChange(true);
    }
  }, [multipleTimes, staggeredBy, onValidationChange]);

  const handleMultipleTimesChange = (e) => {
    const value = e.target.value;
    const numericValue = parseInt(value, 10);

    if (numericValue >= 0 || value === '') {
      setMultipleTimes(value === '' ? '' : numericValue);
      onAdditionalTimesChange(value === '' ? 0 : numericValue);

      if (numericValue === 0) {
        setStaggeredBy('');
        setError('');
        onStaggerMinutesChange(0);
      }
    }
  };

  const handleStaggeredByChange = (e) => {
    const value = e.target.value;
    const numericValue = parseInt(value, 10);

    if (numericValue >= 0 || value === '') {
      setStaggeredBy(value === '' ? '' : numericValue);
      onStaggerMinutesChange(value === '' ? 0 : numericValue);
    }
  };

  return (
    <div className="right-controls">
      {/* <DurationDropdown 
        selectedValue={selectedDuration} 
        handleChange={onDurationChange} 
        disableDropdown={disableDurationDropdown} 
      /> */}
      <StartTimeInput onStartTimeChange={onStartTimeChange} />

      <div className="multiple-times">
        Do you want to choose multiple times on the same date?
      </div>
      <div className="create-times">
        Create{' '}
        <input
          type="number"
          value={multipleTimes}
          onChange={handleMultipleTimesChange}
          min="0"
          className="number-input"
          placeholder="0"
        />{' '}
        additional start times
      </div>

      <div className="staggered-times">
        Staggered by{' '}
        <input
          type="number"
          value={staggeredBy}
          onChange={handleStaggeredByChange}
          min="0"
          className="number-input"
          placeholder="0"
          disabled={multipleTimes === 0}
        />{' '}
        minutes
      </div>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default RightControls;






